// extracted by mini-css-extract-plugin
export default {"pageWrap":"Xa-z","fullWidth":"Ya-z","heading":"Za-z","fullBleed":"_a-z","hidden":"ab-z"};